export class SelfDependencyError extends Error {}

export class InvalidDependencyPairError extends Error {}

export class ReadOnlyAdapterError extends Error {}
